import React from "react";

export const RewardsIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0002 1.66732H11.0002V1.00065C11.0002 0.82384 10.9299 0.654271 10.8049 0.529246C10.6799 0.404222 10.5103 0.333984 10.3335 0.333984H3.66683C3.49002 0.333984 3.32045 0.404222 3.19543 0.529246C3.0704 0.654271 3.00016 0.82384 3.00016 1.00065V1.66732H1.00016C0.823352 1.66732 0.653782 1.73756 0.528758 1.86258C0.403734 1.9876 0.333496 2.15717 0.333496 2.33398V4.33398C0.333496 7.20732 1.53283 8.94065 3.54616 9.00865C3.8409 9.51518 4.24333 9.95077 4.72498 10.2846C5.20663 10.6185 5.75575 10.8424 6.3335 10.9407V12.334H5.00016V13.6673H9.00016V12.334H7.66683V10.9407C8.24444 10.842 8.7934 10.6179 9.27499 10.2841C9.75659 9.9503 10.1591 9.51492 10.4542 9.00865C12.4675 8.94065 13.6668 7.20732 13.6668 4.33398V2.33398C13.6668 2.15717 13.5966 1.9876 13.4716 1.86258C13.3465 1.73756 13.177 1.66732 13.0002 1.66732ZM1.66683 4.33398V3.00065H3.00016V7.55398C1.81083 7.05265 1.66683 5.19998 1.66683 4.33398ZM7.00016 9.66732C5.5295 9.66732 4.3335 8.47132 4.3335 7.00065V1.66732H9.66683V7.00065C9.66683 8.47132 8.47083 9.66732 7.00016 9.66732ZM11.0002 7.55398V3.00065H12.3335V4.33398C12.3335 5.19998 12.1895 7.05265 11.0002 7.55398Z"
        fill="currentColor"
      />
    </svg>
  );
};
